import { styled, css } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { Constrainer } from "../../internal-components/Layout.js";
import { cssSpacing, surfaceColorMap } from "../../util/styles.js";
import type { BackgroundColor } from "../../types/theme.js";

export const Wrapper = styled.div`
  .horizontal-spacer {
    padding: 0;

    @media all and (min-width: ${mobileBreakPointCSS}) {
      padding: 0 ${(props) => props.theme.spacing.l};
    }
  }
`;

export const FormConstrainer = styled(Constrainer)<{ $bg: BackgroundColor }>`
  background-color: ${({ $bg }) => surfaceColorMap[$bg]};
  color: ${({ $bg }) => ($bg === "surface3" ? "#fff" : "var(--swatch2)")};
  svg path { fill: currentColor; stroke: currentColor; }
  border-radius: ${(props) => props.theme.borderRadius};
  padding: ${cssSpacing("l", "m")};

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${cssSpacing("xl", 0)};
  }
`;

export const Form = styled.form`
  padding: 0;

  * {
    box-sizing: border-box;
  }
`;

export const Fields = styled.div`
  @media (min-width: ${mobileBreakPointCSS}) {
    padding: 1px 0;
    margin: calc(-${(props) => props.theme.spacing.m} / 2);
  }
`;

export const ButtonWrapper = styled.div<{ $full?: boolean }>`
  text-align: right;
  margin-top: ${(props) => props.theme.spacing.xs};
  display: flex;
  justify-content: flex-end;
  gap: ${(props) => props.theme.spacing.s};

  @media (min-width: ${mobileBreakPointCSS}) {
    button {
      width: auto;
    }

    ${(props) =>
      !props.$full &&
      css`
        margin-top: ${(props) => props.theme.spacing.m};

        > * {
          width: auto;
        }
      `};
  }
`;

export const Sections = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
`;

export const Section = styled.div<{ $aside?: boolean }>`
  ${(props) =>
    props.$aside &&
    css`
      min-width: 270px;
      width: 100%;

      @media (min-width: ${mobileBreakPointCSS}) {
        width: auto;
      }
    `};

  ${(props) =>
    !props.$aside &&
    css`
      flex: 1;
    `};

  h3 {
    margin-top: 0;
  }
`;

export const IntroText = styled.div`
  text-align: left;
  margin-bottom: ${(props) => props.theme.spacing.m};

  @media (min-width: ${mobileBreakPointCSS}) {
    margin-bottom: ${(props) => props.theme.spacing.l};
  }
`;

export const ClearFix = styled.div`
  clear: both;
`;
